import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AwsAuthService } from '@nx/auth';

@Injectable({
  providedIn: 'root'
})
export class UserSignedInGuard implements CanActivate {
  constructor(private AwsAuthService: AwsAuthService, private router: Router) { };

  canActivate(): Promise<boolean> {
    return this.AwsAuthService.isUserLoggedIn().then(user => {
      if (!user) {
        return true;
      } else {
        this.router.navigate(['/'])
        return false;
      }
    })
  }
}
